import React, { Fragment } from "react";
import { motion } from "framer-motion";

const BlankRows = ({ count = 0 }) => (
  <Fragment>
    {new Array(Math.max(count, 0)).fill(0).map((_, _idx) => (
      <motion.div
        key={"blank-" + _idx}
        className="mb-0 flex h-6 w-full items-center justify-center gap-1 rounded border border-dashed border-slate-300 bg-slate-200 bg-opacity-50 transition-all duration-300 dark:border-slate-700 dark:bg-slate-700"
        initial={{ opacity: 0, translateX: -20 }}
        animate={{ opacity: 1, translateX: 0 }}
        exit={{ opacity: 0, translateX: -20 }}
        transition={{ delay: _idx * 0.1 + 0.2 }}
      ></motion.div>
    ))}
  </Fragment>
);

export default BlankRows;
